const defaultColor = "#393939";
const defaultWidth = 20;
const defaultHeight = 20;

export const AmenityIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon non_stroke_icon ${classname}`}
    >
      <path
        d="M8.64108 15.2781C8.64108 14.5152 9.26647 13.8898 10.0295 13.8898C10.7924 13.8898 11.4178 14.5152 11.4178 15.2781C11.4178 16.0411 10.7924 16.6665 10.0295 16.6665C9.26647 16.6665 8.64108 16.0411 8.64108 15.2781ZM18.147 8.69902C18.4222 8.44886 18.4472 8.01109 18.1971 7.72341C14.0194 3.22059 6.97754 2.95793 2.46222 7.13554C2.26209 7.32316 2.06197 7.52328 1.87435 7.72341C1.59918 7.99858 1.59918 8.43635 1.87435 8.69902C2.14952 8.97419 2.58729 8.97419 2.84996 8.69902C2.86247 8.68651 2.87497 8.674 2.88748 8.6615C6.55228 4.72153 12.7186 4.48388 16.6586 8.14867C16.8337 8.31128 17.0088 8.48639 17.1714 8.6615C17.4341 8.93667 17.8719 8.94918 18.147 8.69902ZM14.6699 12.0386C14.945 11.7885 14.97 11.3507 14.7074 11.063C12.3184 8.48639 8.29086 8.32378 5.71425 10.7128C5.58917 10.8253 5.4766 10.9504 5.36403 11.063C5.08886 11.3382 5.08886 11.7759 5.36403 12.0386C5.6392 12.3138 6.07698 12.3138 6.33964 12.0386C6.35215 12.0261 6.36466 12.0136 6.37717 12.0011C8.25334 9.97482 11.4178 9.86225 13.4441 11.7509C13.5316 11.8385 13.6192 11.9135 13.6942 12.0011C13.9569 12.2763 14.3822 12.3013 14.6699 12.0386Z"
        fill={color}
      />
    </svg>
  );
};

export const ReviewIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M11.4421 2.9252L12.9087 5.85853C13.1087 6.26686 13.6421 6.65853 14.0921 6.73353L16.7504 7.1752C18.4504 7.45853 18.8504 8.69186 17.6254 9.90853L15.5587 11.9752C15.2087 12.3252 15.0171 13.0002 15.1254 13.4835L15.7171 16.0419C16.1837 18.0669 15.1087 18.8502 13.3171 17.7919L10.8254 16.3169C10.3754 16.0502 9.63375 16.0502 9.17541 16.3169L6.68375 17.7919C4.90041 18.8502 3.81708 18.0585 4.28375 16.0419L4.87541 13.4835C4.98375 13.0002 4.79208 12.3252 4.44208 11.9752L2.37541 9.90853C1.15875 8.69186 1.55041 7.45853 3.25041 7.1752L5.90875 6.73353C6.35041 6.65853 6.88375 6.26686 7.08375 5.85853L8.55041 2.9252C9.35041 1.33353 10.6504 1.33353 11.4421 2.9252Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RewardIcons = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M10 12.4998C13.1066 12.4998 15.625 10.0747 15.625 7.08317C15.625 4.09163 13.1066 1.6665 10 1.6665C6.8934 1.6665 4.375 4.09163 4.375 7.08317C4.375 10.0747 6.8934 12.4998 10 12.4998Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.26613 11.2667L6.25781 17.4167C6.25781 18.1667 6.78282 18.5334 7.43282 18.225L9.66614 17.1667C9.84948 17.075 10.1578 17.075 10.3411 17.1667L12.5828 18.225C13.2245 18.525 13.7578 18.1667 13.7578 17.4167V11.1167"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M2.5 7.59163V12.4C2.5 14.1666 2.5 14.1666 4.16667 15.2916L8.75 17.9416C9.44167 18.3416 10.5667 18.3416 11.25 17.9416L15.8333 15.2916C17.5 14.1666 17.5 14.1666 17.5 12.4083V7.59163C17.5 5.8333 17.5 5.8333 15.8333 4.7083L11.25 2.0583C10.5667 1.6583 9.44167 1.6583 8.75 2.0583L4.16667 4.7083C2.5 5.8333 2.5 5.8333 2.5 7.59163Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const APILogsIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M5.30859 7.92482C1.90859 8.16649 1.91693 13.0915 5.30859 13.3331H13.3586C14.3336 13.3415 15.2753 12.9748 16.0003 12.3165C18.3836 10.2332 17.1086 6.06647 13.9669 5.66647C12.8419 -1.11687 3.01694 1.45815 5.34194 7.92482"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3335V15.8335"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.9987 19.1668C10.9192 19.1668 11.6654 18.4206 11.6654 17.5002C11.6654 16.5797 10.9192 15.8335 9.9987 15.8335C9.07822 15.8335 8.33203 16.5797 8.33203 17.5002C8.33203 18.4206 9.07822 19.1668 9.9987 19.1668Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0013 17.5H11.668"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 17.5H5"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BranchesIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M1.91016 6.48348V14.5918C1.91016 16.1751 3.03516 16.8251 4.40182 16.0418L6.36016 14.9251C6.78516 14.6835 7.49349 14.6585 7.93516 14.8835L12.3102 17.0751C12.7518 17.2918 13.4602 17.2751 13.8852 17.0335L17.4935 14.9668C17.9518 14.7001 18.3352 14.0501 18.3352 13.5168V5.40848C18.3352 3.82514 17.2102 3.17514 15.8435 3.95848L13.8852 5.07514C13.4602 5.31681 12.7518 5.34181 12.3102 5.11681L7.93516 2.93348C7.49349 2.71681 6.78516 2.73348 6.36016 2.97514L2.75182 5.04181C2.28516 5.30848 1.91016 5.95848 1.91016 6.48348Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.13281 3.3335V14.1668"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1094 5.5166V16.6666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CityIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M3.0148 7.07484C4.65646 -0.141827 15.3481 -0.133494 16.9815 7.08317C17.9398 11.3165 15.3065 14.8998 12.9981 17.1165C11.3231 18.7332 8.67313 18.7332 6.9898 17.1165C4.6898 14.8998 2.05646 11.3082 3.0148 7.07484Z"
      stroke={color}
      strokeWidth="1.3"
    />
    <path
      d="M9.99844 11.1917C11.4344 11.1917 12.5984 10.0276 12.5984 8.5917C12.5984 7.15576 11.4344 5.9917 9.99844 5.9917C8.5625 5.9917 7.39844 7.15576 7.39844 8.5917C7.39844 10.0276 8.5625 11.1917 9.99844 11.1917Z"
      stroke={color}
      strokeWidth="1.3"
    />
  </svg>
);

export const CouponIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M18.332 4.99984V7.0165C18.332 8.33317 17.4987 9.1665 16.182 9.1665H13.332V3.3415C13.332 2.4165 14.0904 1.6665 15.0154 1.6665C15.9237 1.67484 16.757 2.0415 17.357 2.6415C17.957 3.24984 18.332 4.08317 18.332 4.99984Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66797 5.83317V17.4998C1.66797 18.1915 2.4513 18.5832 3.0013 18.1665L4.4263 17.0998C4.75964 16.8498 5.2263 16.8832 5.5263 17.1832L6.90964 18.5748C7.23464 18.8998 7.76797 18.8998 8.09297 18.5748L9.49297 17.1748C9.78463 16.8832 10.2513 16.8498 10.5763 17.0998L12.0013 18.1665C12.5513 18.5748 13.3346 18.1832 13.3346 17.4998V3.33317C13.3346 2.4165 14.0846 1.6665 15.0013 1.6665H5.83464H5.0013C2.5013 1.6665 1.66797 3.15817 1.66797 4.99984Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.22656 11.4416L9.77656 6.8916"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.93553 11.2502H9.94301"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16209 7.08317H5.16957"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomerIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`sidebar_icon ${classname}`}
  >
    <path
      d="M14.9984 5.96651C14.9484 5.95817 14.8901 5.95817 14.8401 5.96651C13.6901 5.92484 12.7734 4.98317 12.7734 3.81651C12.7734 2.62484 13.7318 1.6665 14.9234 1.6665C16.1151 1.6665 17.0734 2.63317 17.0734 3.81651C17.0651 4.98317 16.1484 5.92484 14.9984 5.96651Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1383 12.0333C15.28 12.225 16.5383 12.025 17.4216 11.4333C18.5966 10.65 18.5966 9.36664 17.4216 8.58331C16.53 7.99164 15.2549 7.79163 14.1133 7.99163"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.97344 5.96651C5.02344 5.95817 5.08177 5.95817 5.13177 5.96651C6.28177 5.92484 7.19844 4.98317 7.19844 3.81651C7.19844 2.62484 6.24011 1.6665 5.04844 1.6665C3.85677 1.6665 2.89844 2.63317 2.89844 3.81651C2.90677 4.98317 3.82344 5.92484 4.97344 5.96651Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0023 12.1916C9.95234 12.1833 9.89401 12.1833 9.84401 12.1916C8.69401 12.1499 7.77734 11.2083 7.77734 10.0416C7.77734 8.84994 8.73568 7.8916 9.92734 7.8916C11.119 7.8916 12.0773 8.85827 12.0773 10.0416C12.069 11.2083 11.1523 12.1583 10.0023 12.1916Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.57656 14.8168C6.40156 15.6001 6.40156 16.8835 7.57656 17.6668C8.9099 18.5585 11.0932 18.5585 12.4266 17.6668C13.6016 16.8835 13.6016 15.6001 12.4266 14.8168C11.1016 13.9335 8.9099 13.9335 7.57656 14.8168Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MeetingRoomIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M4.16797 1.6665H15.668C16.2203 1.6665 16.668 2.11422 16.668 2.6665V14.5554C16.668 15.1077 16.2203 15.5554 15.668 15.5554H13.543M4.16797 1.6665V14.8087C4.16797 15.2516 4.45926 15.6417 4.88388 15.7675L12.2589 17.9527C12.8998 18.1426 13.543 17.6623 13.543 16.9939V5.19096C13.543 4.74809 13.2517 4.35797 12.8271 4.23216L4.16797 1.6665ZM10.418 10.9258V11.8517"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OrderIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M18.332 4.99984V7.0165C18.332 8.33317 17.4987 9.1665 16.182 9.1665H13.332V3.3415C13.332 2.4165 14.0904 1.6665 15.0154 1.6665C15.9237 1.67484 16.757 2.0415 17.357 2.6415C17.957 3.24984 18.332 4.08317 18.332 4.99984Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66797 5.83317V17.4998C1.66797 18.1915 2.45128 18.5832 3.00128 18.1665L4.4263 17.0998C4.75963 16.8498 5.22631 16.8832 5.52631 17.1832L6.90962 18.5748C7.23462 18.8998 7.76799 18.8998 8.09299 18.5748L9.49298 17.1748C9.78465 16.8832 10.2513 16.8498 10.5763 17.0998L12.0013 18.1665C12.5513 18.5748 13.3346 18.1832 13.3346 17.4998V3.33317C13.3346 2.4165 14.0846 1.6665 15.0013 1.6665H5.83464H5.0013C2.5013 1.6665 1.66797 3.15817 1.66797 4.99984V5.83317Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.5H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 10.8335H9.375"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReviewIcon2 = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M15.2667 9.99982C17.4333 9.99982 18.3333 9.16649 17.5333 6.43316C16.9917 4.59149 15.4083 3.00816 13.5667 2.46649C10.8333 1.66649 10 2.56649 10 4.73316V7.13316C10 9.16649 10.8333 9.99982 12.5 9.99982H15.2667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6652 12.2501C15.8902 16.1085 12.1902 18.9085 7.98189 18.2251C4.82356 17.7168 2.28189 15.1751 1.76523 12.0168C1.09023 7.82513 3.87356 4.12513 7.71523 3.3418"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OverviewIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M15.2667 9.99982C17.4333 9.99982 18.3333 9.16649 17.5333 6.43316C16.9917 4.59149 15.4083 3.00816 13.5667 2.46649C10.8333 1.66649 10 2.56649 10 4.73316V7.13316C10 9.16649 10.8333 9.99982 12.5 9.99982H15.2667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6652 12.2501C15.8902 16.1085 12.1902 18.9085 7.98189 18.2251C4.82356 17.7168 2.28189 15.1751 1.76523 12.0168C1.09023 7.82513 3.87356 4.12513 7.71523 3.3418"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M7.63411 9.05817C7.55078 9.04984 7.45078 9.04984 7.35911 9.05817C5.37578 8.9915 3.80078 7.3665 3.80078 5.3665C3.80078 3.32484 5.45078 1.6665 7.50078 1.6665C9.54245 1.6665 11.2008 3.32484 11.2008 5.3665C11.1924 7.3665 9.61745 8.9915 7.63411 9.05817Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6747 3.3335C15.2914 3.3335 16.5914 4.64183 16.5914 6.25016C16.5914 7.82516 15.3414 9.1085 13.7831 9.16683C13.7164 9.1585 13.6414 9.1585 13.5664 9.16683"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.46563 12.1335C1.44896 13.4835 1.44896 15.6835 3.46563 17.0252C5.75729 18.5585 9.51563 18.5585 11.8073 17.0252C13.824 15.6752 13.824 13.4752 11.8073 12.1335C9.52396 10.6085 5.76562 10.6085 3.46563 12.1335Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2852 16.6665C15.8852 16.5415 16.4518 16.2998 16.9185 15.9415C18.2185 14.9665 18.2185 13.3582 16.9185 12.3832C16.4602 12.0332 15.9018 11.7998 15.3102 11.6665"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WebsiteRequestIcon = ({
  color = defaultColor,
  width = 20,
  height = 20,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M6.5 1.0835V4.87516L7.58333 3.79183"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5013 4.87484L5.41797 3.7915"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.07422 7.0415H3.46297C3.6688 7.0415 3.85297 7.15525 3.94505 7.33942L4.5788 8.60692C4.76297 8.97525 5.13672 9.20817 5.54839 9.20817H7.46047C7.87214 9.20817 8.24588 8.97525 8.43005 8.60692L9.0638 7.33942C9.15588 7.15525 9.34547 7.0415 9.54589 7.0415H11.9076"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.79036 2.2373C1.87286 2.51897 1.08203 3.64564 1.08203 5.95855V8.12522C1.08203 10.8336 2.16536 11.9169 4.8737 11.9169H8.1237C10.832 11.9169 11.9154 10.8336 11.9154 8.12522V5.95855C11.9154 3.64564 11.1245 2.51897 9.20703 2.2373"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WorkshopIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M4.9987 1.6665H14.9987C15.9154 1.6665 16.6654 2.4165 16.6654 3.33317V6.93318H3.33203V3.33317C3.33203 2.4165 4.08203 1.6665 4.9987 1.6665Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33203 6.93311V9.89977C3.33203 10.7998 3.81539 11.6331 4.60706 12.0748L7.07369 13.4664C7.59869 13.7581 7.92371 14.3165 7.92371 14.9165V16.6664C7.92371 17.5831 8.67371 18.3331 9.59037 18.3331H10.4237C11.3404 18.3331 12.0904 17.5831 12.0904 16.6664V14.9165C12.0904 14.3165 12.4154 13.7581 12.9404 13.4664L15.407 12.0748C16.1904 11.6331 16.682 10.7998 16.682 9.89977V6.93311H3.33203Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WorkspaceIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M4.64286 15.3571H15.3571M4.64286 15.3571C3.45939 15.3571 2.5 14.3978 2.5 13.2143V8.39286C2.5 7.50525 3.21954 6.78571 4.10714 6.78571C4.29499 6.78571 4.4753 6.81794 4.64286 6.87716M4.64286 15.3571V17.5M15.3571 15.3571C16.5406 15.3571 17.5 14.3978 17.5 13.2143V8.39286C17.5 7.50525 16.7804 6.78571 15.8929 6.78571C15.705 6.78571 15.5247 6.81794 15.3571 6.87716M15.3571 15.3571V17.5M4.64286 6.87716C5.26707 7.09779 5.71429 7.6931 5.71429 8.39286V11.0714H14.2857V8.39286C14.2857 7.6931 14.7329 7.09779 15.3571 6.87716M4.64286 6.87716V6.78571C4.64286 4.41878 6.56164 2.5 8.92857 2.5H11.0714C13.4383 2.5 15.3571 4.41878 15.3571 6.78571V6.87716"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WSManagementIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C14.1667 1.6665 15 3.90817 15 6.6665V8.33317"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 18.3335H5.83464C2.5013 18.3335 1.66797 17.5002 1.66797 14.1668V12.5002C1.66797 9.16683 2.5013 8.3335 5.83464 8.3335H14.168C17.5013 8.3335 18.3346 9.16683 18.3346 12.5002V14.1668C18.3346 17.5002 17.5013 18.3335 14.168 18.3335Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OfficeIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon non_stroke_icon ${classname}`}
    >
      <path
        d="M12.6697 1.77431C12.9746 1.77531 13.2796 1.77632 13.5938 1.77736C14.0512 1.76981 14.0512 1.76981 14.5178 1.7621C14.8091 1.7619 15.1003 1.7617 15.4004 1.76149C15.6681 1.76056 15.9358 1.75963 16.2115 1.75867C16.54 1.81626 16.54 1.81626 16.875 1.87502C17.619 2.99102 17.5841 3.52087 17.5781 4.84377C17.5805 5.38034 17.5805 5.38034 17.583 5.92775C17.5 6.87502 17.5 6.87502 16.875 7.81252C16.0547 7.87111 16.0547 7.87111 15.3125 7.81252C15.3125 8.12189 15.3125 8.43127 15.3125 8.75002C16.2406 8.75002 17.1688 8.75002 18.125 8.75002C18.125 9.05939 18.125 9.36877 18.125 9.68752C17.9187 9.68752 17.7125 9.68752 17.5 9.68752C17.5 12.4719 17.5 15.2563 17.5 18.125C16.4688 18.125 15.4375 18.125 14.375 18.125C14.375 17.8156 14.375 17.5063 14.375 17.1875C11.4875 17.1875 8.6 17.1875 5.625 17.1875C5.625 17.4969 5.625 17.8063 5.625 18.125C4.59375 18.125 3.5625 18.125 2.5 18.125C2.5 15.3406 2.5 12.5563 2.5 9.68752C2.29375 9.68752 2.0875 9.68752 1.875 9.68752C1.875 9.37814 1.875 9.06877 1.875 8.75002C2.05547 8.73712 2.23594 8.72423 2.42188 8.71095C3.47375 8.30189 3.79089 7.49708 4.375 6.56252C5.4563 6.02187 6.63023 6.09891 7.8125 6.25002C8.90591 6.91061 9.28306 7.22419 9.6875 8.43752C10.3063 8.43752 10.925 8.43752 11.5625 8.43752C11.6656 8.23127 11.7687 8.02502 11.875 7.81252C11.6301 7.82541 11.3852 7.8383 11.1328 7.85158C10.3125 7.81252 10.3125 7.81252 9.6875 7.18752C9.62547 6.39209 9.60046 5.6384 9.60938 4.84377C9.60696 4.62825 9.60454 4.41273 9.60205 4.19069C9.61159 1.74495 10.5241 1.79063 12.6697 1.77431ZM10.625 3.12502C10.6024 3.70404 10.5988 4.28387 10.6055 4.8633C10.6083 5.17952 10.6111 5.49574 10.614 5.82155C10.6176 6.06607 10.6213 6.31059 10.625 6.56252C11.3984 6.7172 11.3984 6.7172 12.1875 6.87502C12.2906 6.35939 12.3937 5.84377 12.5 5.31252C13.5828 5.15783 13.5828 5.15783 14.6875 5.00002C14.7906 5.61877 14.8937 6.23752 15 6.87502C15.5156 6.77189 16.0312 6.66877 16.5625 6.56252C16.5709 5.99613 16.577 5.42972 16.582 4.8633C16.5875 4.39017 16.5875 4.39017 16.593 3.90749C16.6519 3.1437 16.6519 3.1437 16.25 2.81252C15.3615 2.78131 14.4822 2.76915 13.5938 2.77345C13.3444 2.77224 13.095 2.77104 12.8381 2.76979C11.6349 2.65345 11.6349 2.65345 10.625 3.12502ZM13.125 5.93752C13.0219 6.86564 12.9188 7.79377 12.8125 8.75002C13.3281 8.75002 13.8437 8.75002 14.375 8.75002C14.2719 7.92502 14.1688 7.10002 14.0625 6.25002C13.7531 6.14689 13.4437 6.04377 13.125 5.93752ZM4.375 8.12502C4.375 8.33127 4.375 8.53752 4.375 8.75002C5.71562 8.75002 7.05625 8.75002 8.4375 8.75002C7.94426 7.59884 7.94426 7.59884 7.5 7.18752C6.13198 7.06591 5.3652 7.13482 4.375 8.12502ZM3.4375 9.68752C3.4375 12.1625 3.4375 14.6375 3.4375 17.1875C3.95312 17.0844 4.46875 16.9813 5 16.875C5 16.6688 5 16.4625 5 16.25C8.3 16.25 11.6 16.25 15 16.25C15.1547 16.7141 15.1547 16.7141 15.3125 17.1875C15.725 17.1875 16.1375 17.1875 16.5625 17.1875C16.5625 14.7125 16.5625 12.2375 16.5625 9.68752C12.2313 9.68752 7.9 9.68752 3.4375 9.68752Z"
        fill={color}
      />
      <path
        d="M6.36726 2.08984C7.50007 2.1875 7.50007 2.1875 8.12507 2.69531C8.54757 3.69874 8.43898 4.28108 8.12507 5.3125C7.18757 5.9375 7.18757 5.9375 6.25007 5.91797C5.31257 5.625 5.31257 5.625 4.68757 4.92188C4.37507 4.0625 4.37507 4.0625 4.60945 3.20312C5.16615 2.20106 5.16615 2.20106 6.36726 2.08984ZM5.93757 3.125C5.83445 3.64062 5.73132 4.15625 5.62507 4.6875C5.93445 4.79063 6.24382 4.89375 6.56257 5C6.87195 4.69062 7.18132 4.38125 7.50007 4.0625C7.29382 3.75312 7.08757 3.44375 6.87507 3.125C6.5657 3.125 6.25632 3.125 5.93757 3.125Z"
        fill={color}
      />
    </svg>
  );
};

export const HotDeskIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon non_stroke_icon ${classname}`}
    >
      <path
        d="M19.2988 7.29883H17.7988V15.2988H15.6992V11.2988H9.69922V7.29883H3.79883V15.2988H1.69922V7.29883H0.699219V4.69922H19.2988V7.29883ZM2.29883 14.6992H3.19922V7.29883H2.29883V14.6992ZM16.2988 14.6992H17.1992V7.29883H16.2988V14.6992ZM10.2988 10.6992H15.6992V9.29883H14V9.5H12V9.29883H10.2988V10.6992ZM10.2988 8.69922H15.6992V7.29883H14V7.5H12V7.29883H10.2988V8.69922ZM1.29883 6.69922H18.6992V5.29883H1.29883V6.69922Z"
        fill={color}
      />
    </svg>
  );
};
export const MyPlanIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  classname = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`sidebar_icon ${classname}`}
    >
      <path
        d="M1.6665 7.08789H18.3332"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 13.7539H6.66667"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 13.7539H12.0833"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3665 2.9209H14.6248C17.5915 2.9209 18.3332 3.65423 18.3332 6.57923V13.4209C18.3332 16.3459 17.5915 17.0792 14.6332 17.0792H5.3665C2.40817 17.0876 1.6665 16.3542 1.6665 13.4292V6.57923C1.6665 3.65423 2.40817 2.9209 5.3665 2.9209Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DollarIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
    >
      <path
        d="M8.67188 14.51C8.67188 15.8 9.66188 16.84 10.8919 16.84H13.4019C14.4719 16.84 15.3419 15.93 15.3419 14.81C15.3419 13.59 14.8119 13.16 14.0219 12.88L9.99187 11.48C9.20187 11.2 8.67188 10.77 8.67188 9.55002C8.67188 8.43002 9.54187 7.52002 10.6119 7.52002H13.1219C14.3519 7.52002 15.3419 8.56002 15.3419 9.85002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6.18018V18.1802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.1802C17.5228 22.1802 22 17.703 22 12.1802C22 6.65733 17.5228 2.18018 12 2.18018C6.47715 2.18018 2 6.65733 2 12.1802C2 17.703 6.47715 22.1802 12 22.1802Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AverageBookingsIcon = ({
  color = defaultColor,
  width = 24,
  height = 24,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
    >
      <g id="vuesax/linear/favorite-chart">
        <g id="favorite-chart">
          <path
            id="Vector"
            d="M22 13.1802V9.18018C22 4.18018 20 2.18018 15 2.18018H9C4 2.18018 2 4.18018 2 9.18018V15.1802C2 20.1802 4 22.1802 9 22.1802H13"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M7.32812 14.67L9.70813 11.5799C10.0481 11.1399 10.6781 11.0599 11.1181 11.3999L12.9482 12.84C13.3882 13.18 14.0181 13.1 14.3581 12.67L16.6682 9.68994"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="Group">
            <path
              id="Vector_3"
              d="M19.4812 16.0001L19.7612 16.5701C19.9012 16.8501 20.2512 17.1101 20.5612 17.1701L20.9412 17.2301C22.0812 17.4201 22.3512 18.2601 21.5312 19.0901L21.1812 19.4401C20.9512 19.6801 20.8212 20.1401 20.8912 20.4601L20.9412 20.6701C21.2512 22.0501 20.5212 22.5801 19.3212 21.8601L19.0612 21.7101C18.7512 21.5301 18.2512 21.5301 17.9412 21.7101L17.6812 21.8601C16.4712 22.5901 15.7412 22.0501 16.0612 20.6701L16.1112 20.4601C16.1812 20.1401 16.0512 19.6801 15.8212 19.4401L15.4712 19.0901C14.6512 18.2601 14.9212 17.4201 16.0612 17.2301L16.4412 17.1701C16.7412 17.1201 17.1012 16.8501 17.2412 16.5701L17.5212 16.0001C18.0612 14.9101 18.9412 14.9101 19.4812 16.0001Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const RevenueOverviewIcon = ({
  color = "#C4D26E",
  width = "24",
  height = "25",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="vuesax/linear/diagram">
        <g id="diagram">
          <path
            id="Vector"
            d="M2 2.18018V19.1802C2 20.8402 3.34 22.1802 5 22.1802H22"
            stroke={color}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M5 17.1802L9.59 11.8202C10.35 10.9402 11.7 10.8802 12.52 11.7102L13.47 12.6602C14.29 13.4802 15.64 13.4302 16.4 12.5502L21 7.18018"
            stroke={color}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
export const DashboardCouponIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.64411 10.671C4.08828 10.1943 4.76536 10.2322 5.15536 10.7522L5.70245 11.4835C6.1412 12.0631 6.85078 12.0631 7.28953 11.4835L7.83661 10.7522C8.22661 10.2322 8.9037 10.1943 9.34786 10.671C10.312 11.7002 11.0974 11.3589 11.0974 9.91808V3.8135C11.1029 1.63058 10.5937 1.0835 8.5462 1.0835H4.4512C2.4037 1.0835 1.89453 1.63058 1.89453 3.8135V9.91266C1.89453 11.3589 2.68536 11.6947 3.64411 10.671Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 7.0415L8.125 3.7915"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.12333 7.04183H8.12819"
        stroke="#A4A4A4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.87333 4.06234H4.87819"
        stroke="#A4A4A4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UsedCouponIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="vuesax/linear/ticket-discount">
        <g id="ticket-discount">
          <path
            id="Vector"
            d="M19.5 12.6802C19.5 11.3002 20.62 10.1802 22 10.1802V9.18018C22 5.18018 21 4.18018 17 4.18018H7C3 4.18018 2 5.18018 2 9.18018V9.68018C3.38 9.68018 4.5 10.8002 4.5 12.1802C4.5 13.5602 3.38 14.6802 2 14.6802V15.1802C2 19.1802 3 20.1802 7 20.1802H17C21 20.1802 22 19.1802 22 15.1802C20.62 15.1802 19.5 14.0602 19.5 12.6802Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M9 14.9302L15 8.93018"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M14.9945 14.9302H15.0035"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M8.99451 9.43018H9.00349"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
export const RedemptionRateIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.9023 20.0503H17.3723C21.0723 20.0503 21.9923 19.1303 21.9923 15.4303C20.7123 15.4303 19.6823 14.3903 19.6823 13.1203C19.6823 11.8403 20.7123 10.8003 21.9923 10.8003V9.88025C21.9923 6.18025 21.0723 5.26025 17.3723 5.26025H10.9923V12.0503"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9936 17.0502V20.0502H8.22356C6.74356 20.0502 5.87357 19.0402 4.91357 16.7202L4.73356 16.2702C5.94356 15.7902 6.53357 14.3902 6.02357 13.1802C5.53357 11.9702 4.14357 11.3902 2.92357 11.8902L2.75357 11.4602C1.31356 7.94018 1.81357 6.71018 5.33357 5.26018L7.97357 4.18018L10.9936 11.5002V14.0502"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16219 20.0503H7.99219"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CashbackIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="vuesax/linear/coin">
        <path
          id="Vector"
          d="M18.5 12.8301V16.5301C18.5 19.6501 15.59 22.1801 12 22.1801C8.41 22.1801 5.5 19.6501 5.5 16.5301V12.8301C5.5 15.9501 8.41 18.1801 12 18.1801C15.59 18.1801 18.5 15.9501 18.5 12.8301Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M18.5 7.83018C18.5 8.74018 18.25 9.58017 17.81 10.3002C16.74 12.0602 14.54 13.1802 12 13.1802C9.46 13.1802 7.26 12.0602 6.19 10.3002C5.75 9.58017 5.5 8.74018 5.5 7.83018C5.5 6.27018 6.22999 4.86018 7.39999 3.84018C8.57999 2.81018 10.2 2.18018 12 2.18018C13.8 2.18018 15.42 2.81018 16.6 3.83018C17.77 4.86018 18.5 6.27018 18.5 7.83018Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M18.5 7.83018V12.8302C18.5 15.9502 15.59 18.1802 12 18.1802C8.41 18.1802 5.5 15.9502 5.5 12.8302V7.83018C5.5 4.71018 8.41 2.18018 12 2.18018C13.8 2.18018 15.42 2.81018 16.6 3.83018C17.77 4.86018 18.5 6.27018 18.5 7.83018Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const UsedCashBackIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.5 13.9304C9.5 14.9004 10.25 15.6804 11.17 15.6804H13.05C13.85 15.6804 14.5 15.0004 14.5 14.1504C14.5 13.2404 14.1 12.9104 13.51 12.7004L10.5 11.6504C9.91 11.4404 9.51001 11.1204 9.51001 10.2004C9.51001 9.36041 10.16 8.67041 10.96 8.67041H12.84C13.76 8.67041 14.51 9.45041 14.51 10.4204"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.68018V16.6802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12.1802C22 17.7002 17.52 22.1802 12 22.1802C6.48 22.1802 2 17.7002 2 12.1802C2 6.66018 6.48 2.18018 12 2.18018"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6.18018V2.18018H18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7.18018L22 2.18018"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TotalCashbackIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.5 13.9304C9.5 14.9004 10.25 15.6804 11.17 15.6804H13.05C13.85 15.6804 14.5 15.0004 14.5 14.1504C14.5 13.2404 14.1 12.9104 13.51 12.7004L10.5 11.6504C9.91 11.4404 9.51001 11.1204 9.51001 10.2004C9.51001 9.36041 10.16 8.67041 10.96 8.67041H12.84C13.76 8.67041 14.51 9.45041 14.51 10.4204"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.68018V16.6802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12.1802C22 17.7002 17.52 22.1802 12 22.1802C6.48 22.1802 2 17.7002 2 12.1802C2 6.66018 6.48 2.18018 12 2.18018"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 3.18018V7.18018H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 2.18018L17 7.18018"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BookingPerformanceIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="vuesax/linear/chair">
        <path
          id="Vector"
          d="M5.57143 18.6087H18.4286M5.57143 18.6087C4.15127 18.6087 3 17.4575 3 16.0373V10.2516C3 9.18648 3.86345 8.32303 4.92857 8.32303C5.15398 8.32303 5.37036 8.36171 5.57143 8.43277M5.57143 18.6087V21.1802M18.4286 18.6087C19.8488 18.6087 21 17.4575 21 16.0373V10.2516C21 9.18648 20.1365 8.32303 19.0714 8.32303C18.846 8.32303 18.6297 8.36171 18.4286 8.43277M18.4286 18.6087V21.1802M5.57143 8.43277C6.32049 8.69752 6.85714 9.41189 6.85714 10.2516V13.4659H17.1429V10.2516C17.1429 9.41189 17.6795 8.69752 18.4286 8.43277M5.57143 8.43277V8.32303C5.57143 5.48271 7.87396 3.18018 10.7143 3.18018H13.2857C16.126 3.18018 18.4286 5.48271 18.4286 8.32303V8.43277"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const OccupancyRateIcon = ({
  color = defaultColor,
  width = "24",
  height = "24",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2 22.1802H22"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.01 22.17L3.01001 22.19L3 7.25004C3 6.58004 3.34001 5.96 3.89001 5.59L7.89001 2.92002C8.56001 2.47002 9.43999 2.47002 10.11 2.92002L14.11 5.59C14.67 5.96 15 6.58004 15 7.25004L15.01 22.17Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9805 22.1902V18.1802"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 12.1802C18.9 12.1802 18 13.0802 18 14.1802V16.1802C18 17.2802 18.9 18.1802 20 18.1802C21.1 18.1802 22 17.2802 22 16.1802V14.1802C22 13.0802 21.1 12.1802 20 12.1802Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14.1802H15"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22.1802V18.4302"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10.6802C9.82843 10.6802 10.5 10.0086 10.5 9.18018C10.5 8.35175 9.82843 7.68018 9 7.68018C8.17157 7.68018 7.5 8.35175 7.5 9.18018C7.5 10.0086 8.17157 10.6802 9 10.6802Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DashboardOverViewUserIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.5013 6.50016C7.99707 6.50016 9.20963 5.2876 9.20963 3.79183C9.20963 2.29606 7.99707 1.0835 6.5013 1.0835C5.00553 1.0835 3.79297 2.29606 3.79297 3.79183C3.79297 5.2876 5.00553 6.50016 6.5013 6.50016Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1535 11.9167C11.1535 9.82042 9.06807 8.125 6.50057 8.125C3.93307 8.125 1.84766 9.82042 1.84766 11.9167"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashboardOverViewUsersIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="vuesax/linear/people">
        <g id="people">
          <g id="Group">
            <path
              id="Vector"
              d="M17.9981 7.34018C17.9381 7.33018 17.8681 7.33018 17.8081 7.34018C16.4281 7.29018 15.3281 6.16018 15.3281 4.76018C15.3281 3.33018 16.4781 2.18018 17.9081 2.18018C19.3381 2.18018 20.4881 3.34018 20.4881 4.76018C20.4781 6.16018 19.3781 7.29018 17.9981 7.34018Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              d="M16.9675 14.6203C18.3375 14.8503 19.8475 14.6103 20.9075 13.9003C22.3175 12.9603 22.3175 11.4203 20.9075 10.4803C19.8375 9.77034 18.3075 9.53033 16.9375 9.77033"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g id="Group_2">
            <path
              id="Vector_3"
              d="M5.97047 7.34018C6.03047 7.33018 6.10047 7.33018 6.16047 7.34018C7.54047 7.29018 8.64047 6.16018 8.64047 4.76018C8.64047 3.33018 7.49047 2.18018 6.06047 2.18018C4.63047 2.18018 3.48047 3.34018 3.48047 4.76018C3.49047 6.16018 4.59047 7.29018 5.97047 7.34018Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_4"
              d="M7.0014 14.6203C5.6314 14.8503 4.12141 14.6103 3.06141 13.9003C1.65141 12.9603 1.65141 11.4203 3.06141 10.4803C4.13141 9.77034 5.6614 9.53033 7.0314 9.77033"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g id="Group_3">
            <path
              id="Vector_5"
              d="M11.9981 14.8104C11.9381 14.8004 11.8681 14.8004 11.8081 14.8104C10.4281 14.7604 9.32812 13.6304 9.32812 12.2304C9.32812 10.8004 10.4781 9.65039 11.9081 9.65039C13.3381 9.65039 14.4881 10.8104 14.4881 12.2304C14.4781 13.6304 13.3781 14.7704 11.9981 14.8104Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_6"
              d="M9.08875 17.9605C7.67875 18.9005 7.67875 20.4405 9.08875 21.3805C10.6888 22.4505 13.3087 22.4505 14.9087 21.3805C16.3187 20.4405 16.3187 18.9005 14.9087 17.9605C13.3187 16.9005 10.6888 16.9005 9.08875 17.9605Z"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const DashboardOverViewUsers2Icon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.15859 11.0502C9.05859 11.0402 8.93859 11.0402 8.82859 11.0502C6.44859 10.9702 4.55859 9.02018 4.55859 6.62018C4.55859 4.17018 6.53859 2.18018 8.99859 2.18018C11.4486 2.18018 13.4386 4.17018 13.4386 6.62018C13.4286 9.02018 11.5386 10.9702 9.15859 11.0502Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4112 4.18018C18.3512 4.18018 19.9112 5.75018 19.9112 7.68018C19.9112 9.57018 18.4113 11.1102 16.5413 11.1802C16.4613 11.1702 16.3713 11.1702 16.2812 11.1802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.15875 14.7402C1.73875 16.3602 1.73875 19.0002 4.15875 20.6102C6.90875 22.4502 11.4188 22.4502 14.1688 20.6102C16.5888 18.9902 16.5888 16.3502 14.1688 14.7402C11.4288 12.9102 6.91875 12.9102 4.15875 14.7402Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3398 20.1802C19.0598 20.0302 19.7398 19.7402 20.2998 19.3102C21.8598 18.1402 21.8598 16.2102 20.2998 15.0402C19.7498 14.6202 19.0798 14.3402 18.3698 14.1802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DashboardOverViewRetentionRateIcon = ({
  color = "#C4D26E",
  width = "24",
  height = "23",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="churn">
        <path
          id="Vector"
          d="M1.59863 10.9282C1.68969 10.8377 1.83108 10.8261 1.93457 10.894L1.97559 10.9282L2.99707 11.9458C3.08711 12.0355 3.09888 12.1732 3.03125 12.2749L2.99707 12.3159C2.93774 12.3748 2.85711 12.4002 2.77734 12.3911L2.10156 12.3149L2.23047 12.9829C3.10867 17.5624 7.14922 21.021 12 21.021C15.9499 21.021 19.3641 18.7278 20.9697 15.4019L21.1191 15.0776C21.1699 14.9618 21.296 14.8987 21.418 14.9243L21.4697 14.9409C21.5879 14.9923 21.6483 15.1174 21.623 15.2358L21.6074 15.2866C19.9911 18.9704 16.2984 21.5464 12 21.5464C6.75826 21.5464 2.41669 17.7148 1.64355 12.7144L1.53223 11.9927L0.899414 12.3579C0.822421 12.4022 0.728234 12.4047 0.649414 12.3667L0.577148 12.3159C0.487224 12.2264 0.475708 12.0885 0.542969 11.9868L0.577148 11.9458L1.59863 10.9282ZM12 0.680176C17.2417 0.680176 21.5832 4.51185 22.3564 9.51221L22.4678 10.2339L23.1006 9.86865C23.1775 9.82449 23.2719 9.82201 23.3506 9.85986L23.4229 9.91162C23.5128 10.0013 23.5245 10.1391 23.457 10.2407L23.4229 10.2817L22.4014 11.2983C22.3103 11.3891 22.169 11.4007 22.0654 11.3325L22.0244 11.2983L21.0029 10.2817C20.913 10.1921 20.9014 10.0543 20.9688 9.95264L21.0029 9.91162C21.0623 9.85252 21.1428 9.82636 21.2227 9.83545L21.8984 9.9126L21.7695 9.24463C20.8915 4.66487 16.8509 1.20557 12 1.20557C8.05021 1.20557 4.63595 3.499 3.03027 6.82471L2.88086 7.1499C2.83001 7.26564 2.70395 7.32793 2.58203 7.30225L2.53027 7.28564C2.41198 7.23417 2.35142 7.10926 2.37695 6.99072L2.39258 6.94092C4.00882 3.25704 7.70152 0.680177 12 0.680176Z"
          fill="black"
          stroke={color}
        />
        <path
          id="Vector_2"
          d="M11.999 14.9189C13.5052 14.919 15.1 15.5245 16.4023 16.1904L16.9414 16.4785C17.464 16.7685 17.9274 17.0586 18.3027 17.3076L18.6475 17.541C18.7449 17.6086 18.8314 17.6735 18.9092 17.7295C18.8647 17.7851 18.8143 17.849 18.7568 17.9209L19.1475 18.2334L19.3535 18.3975L19.1895 18.6025L18.9814 18.4375L18.9785 18.4355L18.9717 18.4307L18.9697 18.4287L18.9414 18.4072L18.9404 18.4062L18.8154 18.3115L18.3418 17.9717C18.0366 17.7599 17.6362 17.4946 17.1689 17.2168L16.6807 16.9365C15.3159 16.1792 13.5786 15.4444 11.999 15.4443C10.6167 15.4443 9.11329 16.0072 7.84473 16.6553L7.31641 16.9365C6.80815 17.2186 6.35675 17.5006 5.99121 17.7432L5.65527 17.9717L5.18164 18.3115L5.05762 18.4062L5.05664 18.4072L5.02734 18.4287L5.02539 18.4307L5.01953 18.4355L5.01465 18.4395L4.80664 18.6035L4.64258 18.3975L4.84961 18.2334L5.24023 17.9209L5.13184 17.7852C5.1163 17.7657 5.10117 17.7473 5.08691 17.7295L5.34961 17.541C5.66297 17.3236 6.07454 17.0521 6.55469 16.7666L7.05566 16.4785C8.43981 15.7104 10.2777 14.9189 11.999 14.9189Z"
          fill="black"
          stroke={color}
        />
        <path
          id="Vector_3"
          d="M12.002 6.78271C13.8426 6.78287 15.3308 8.26822 15.3311 10.0962C15.3311 11.9244 13.8428 13.4105 12.002 13.4106C10.161 13.4106 8.67188 11.9245 8.67188 10.0962C8.67213 8.26813 10.1612 6.78271 12.002 6.78271ZM12.002 7.30811C10.4589 7.30811 9.20436 8.5545 9.2041 10.0962C9.2041 11.6381 10.4587 12.8853 12.002 12.8853C13.5451 12.8851 14.7998 11.638 14.7998 10.0962C14.7995 8.55459 13.5449 7.30826 12.002 7.30811Z"
          fill="black"
          stroke={color}
        />
      </g>
    </svg>
  );
};
export const DashboardOverViewCompletedBooklingsIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="vuesax/linear/tick-circle">
        <g id="tick-circle">
          <path
            id="Vector"
            d="M12 22.1802C17.5 22.1802 22 17.6802 22 12.1802C22 6.68018 17.5 2.18018 12 2.18018C6.5 2.18018 2 6.68018 2 12.1802C2 17.6802 6.5 22.1802 12 22.1802Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M7.75 12.1801L10.58 15.0101L16.25 9.3501"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
export const PrimaryRiyalIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_388_3693)">
        <mask
          id="mask0_388_3693"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="29"
        >
          <path d="M25 0.529297H0V28.4704H25V0.529297Z" fill="white" />
        </mask>
        <g mask="url(#mask0_388_3693)">
          <path
            d="M15.5571 25.2823C15.111 26.2715 14.8161 27.345 14.7031 28.4707L24.1439 26.4638C24.59 25.4749 24.8847 24.4012 24.9979 23.2754L15.5571 25.2823Z"
            fill={color}
          />
          <path
            d="M24.146 20.4512C24.5921 19.4622 24.887 18.3885 25 17.2628L17.6459 18.8268V15.8201L24.1458 14.4388C24.5919 13.4498 24.8868 12.3761 24.9998 11.2504L17.6457 12.8131V1.99998C16.5189 2.63268 15.5181 3.47488 14.7046 4.46831V13.4385L11.7634 14.0636V0.529297C10.6366 1.16178 9.63581 2.0042 8.8223 2.99763V14.6886L2.24149 16.087C1.79537 17.0759 1.50026 18.1497 1.38706 19.2754L8.8223 17.6953V21.4818L0.853986 23.1751C0.407867 24.164 0.112975 25.2377 0 26.3635L8.3406 24.591C9.01956 24.4498 9.60312 24.0484 9.98252 23.496L11.5121 21.2282C11.6709 20.9936 11.7634 20.7103 11.7634 20.4056V17.0702L14.7046 16.445V22.4585L24.146 20.4512Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_388_3693">
          <rect width="25" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SuccessIcon = ({
  color = defaultColor,
  width = "70",
  height = "70",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M40.0013 73.3333C58.3346 73.3333 73.3346 58.3333 73.3346 40C73.3346 21.6666 58.3346 6.66663 40.0013 6.66663C21.668 6.66663 6.66797 21.6666 6.66797 40C6.66797 58.3333 21.668 73.3333 40.0013 73.3333Z"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.832 40L35.2654 49.4333L54.1654 30.5667"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UserProfileIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="42" height="42.8787" fill="white" />
      <rect
        x="2"
        y="2"
        width="38"
        height="38.8787"
        rx="19"
        fill="#ECECEC"
        stroke={color}
        strokeWidth="4"
      />
      <path
        d="M27.037 17.6435C27.0135 16.9313 26.5073 16.3545 25.8011 16.2486C23.3645 15.8661 20.716 16.5782 18.6502 18.4027C16.5844 20.2272 15.5603 22.7697 15.6368 25.2358C15.6603 25.9479 16.1665 26.5247 16.8728 26.6306C19.3094 27.0132 21.9578 26.301 24.0236 24.4765C26.0895 22.652 27.1135 20.1095 27.037 17.6435Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export const CalendarPrimaryIcon = ({
  color = defaultColor,
  width = defaultWidth,
  height = defaultHeight,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.33203 1.5835V3.2085"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66797 1.5835V3.2085"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.89453 5.42383H11.1029"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 5.10433V9.7085C11.375 11.3335 10.5625 12.4168 8.66667 12.4168H4.33333C2.4375 12.4168 1.625 11.3335 1.625 9.7085V5.10433C1.625 3.47933 2.4375 2.396 4.33333 2.396H8.66667C10.5625 2.396 11.375 3.47933 11.375 5.10433Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
